<app-nav-bar></app-nav-bar>

<div id="layoutSidenav">
  <app-side-bar></app-side-bar>

  <div id="layoutSidenav_content">
    <main>
      <div class="container-fluid">
        <h1 class="mt-4">Carga de documentos</h1>
        <!-- <div class="row">
          <div class="col-xl-6">
            <p>Selecciona el tipo de documento</p>
            <select
              class="col-md-6 custom-select"
              [(ngModel)]="selectedDoc"
              #selectDoc
              (change)="reset2ndContentNArrayLog(selectDoc.value)"
            >
              <option value="{{ doc }}" *ngFor="let doc of documents">
                {{ doc }}
              </option>
              >
            </select>
          </div>
        </div> -->

        <div class="row" style="padding-top: 1%">
          <div class="card" style="width: 22rem">
            <div class="card-body">
              <h4 class="card-title">1</h4>
              <p class="card-text">Selecciona el tipo de documento</p>
              <select
                class="col-md-6 custom-select"
                [(ngModel)]="selectedDoc"
                #selectDoc
                (change)="reset2ndContentNArrayLog(selectDoc.value)"
              >
                <option value="{{ doc }}" *ngFor="let doc of documents">
                  {{ doc }}
                </option>
                >
              </select>
            </div>
            <br />
          </div>

          <div class="card" style="width: 22rem">
            <div class="card-body">
              <h4 class="card-title">2</h4>
              <p class="card-text">Debes descargar el documento a llenar.</p>
              <button
                class="btn btn-warning text-white"
                type="button"
                (click)="downloadDocument()"
              >
                <i class="fas fa-download"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="card" style="width: 22rem">
            <div class="card-body">
              <h4 class="card-title">3</h4>
              <!-- <p class="card-text">
                Arrastra un archivo .xlsx o da clic para seleccionarlo
              </p> -->

              <!-- 
                <label for="file-upload" class="custom-file-upload">
                    <i class="fa fa-cloud-upload"></i> Custom Upload
                </label>
                <input id="file-upload" type="file"/>
               -->
              <!-- <div class="area">
                <input type="file" id="upload" />
              </div> -->
              <form enctype="multipart/form-data" class="form-group inputDnD">
                <!-- <label for="uploadfile"
                  ><i class="fas fa-file-excel"></i
                ></label> -->
                <input
                  class="btn form-control-file"
                  name="uploadfile"
                  type="file"
                  value=""
                  id="uploadfile"
                  (change)="selectOrUploadFile($event)"
                  data-title="Arrastra o selecciona un archivo .xlsx"
                />
              </form>
            </div>
          </div>

          <div class="card" style="width: 22rem">
            <div class="card-body">
              <h4 class="card-title">4</h4>
              <p class="card-text">Validar documento.</p>
              <br />
              <button
                class="btn btn-success"
                type="submit"
                id="btnUploadFile"
                (click)="postDocument()"
              >
                <i class="fas fa-upload"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="row" style="padding-top: 3%">
          <!-- <div class="col-xl-6 col-md-3"> -->
          <div class="accordion" id="accordionExample" style="width: 22rem">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button
                    aria-controls="collapseOne"
                    aria-expanded="true"
                    class="btn btn-link btn-block text-left text-dark"
                    data-target="#collapseOne"
                    data-toggle="collapse"
                    type="button"
                  >
                    Log de eventos
                  </button>
                </h2>
              </div>
              <div
                aria-labelledby="headingOne"
                class="collapse"
                data-parent="#accordionExample"
                id="collapseOne"
                style="color: black"
              >
                <div class="card-body">
                  <ul *ngFor="let log of arrayLog; let i = index">
                    <li>{{ log }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </main>

    <footer class="py-4 bg-light mt-auto">
      <div class="container-fluid">
        <div class="d-flex align-items-center justify-content-between small">
          <div class="text-muted">Copyright &copy; Your Website 2020</div>
          <div>
            <a href="#">Privacy Policy</a>
            &middot;
            <a href="#">Terms &amp; Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</div>
